<template>
  <div>
    <div class="mt-3 pb-3 card shadow-sm" v-for="(label, labelIdx) in manualLabels" :key="labelIdx">
    <p class="card-header float-left">{{ label.name }}:得点率</p>
    <!-- gameごとのループ -->
    <div id="manual-label-table" class="mt-3 container">
      <div v-for="(set, setIdx) in tableData(label)" :key="setIdx">
        <div>{{ setIdx + Math.max(matchCnt,1)}}ゲーム目</div>
          <table class="table mb-1 mx-auto table-sm text-secondary table-responsive-xl">
            <tbody>
            <!-- pointごとのループ -->
              <tr>
                <td v-for="(point, pointIdx) in set" class="solid p-0" :key="pointIdx">
                  <div v-if="point == 1" class="solid lblue p-2">{{ space }}</div>
                  <div v-else-if="point == 2" class="solid lgreen p-2">{{ space }}</div>
                  <div v-else class="p-2">{{ space }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="manual-label-point-rate" class="mt-3 scroll">
      <!-- labelを渡して、グラフをchartData, optionDataを再計算して、子コンポーネントに渡す処理 -->
        <horizontal-bar-chart
          :chartData="chartData(label)" :optionData="optionData()" :height="150"/>
      </div>
    </div>
  </div>
</template>

<script>
import func from '@/lib/func';
import HorizontalBarChart from '@/components/atoms/HorizontalBarChart';

export default {
  name: 'manual-labels-chart-wrap',
  components: {
    HorizontalBarChart,
  },
  props: ['points', 'gameInfo', 'manualLabels', 'matchCnt'],
  data() {
    return {
      space: ' ',
      calcRate: {},
    };
  },
  methods: {
    chartData(manualLabel) {
      const rate = this.getRate(this.points, manualLabel);
      return {
        labels: [`${this.gameInfo.player1Name} : ${manualLabel.name}時`,
          `${this.gameInfo.player2Name} : ${manualLabel.name}時`],
        datasets: [
          {
            label: this.gameInfo.player1Name,
            backgroundColor: '#82B8D7',
            data: [rate.l1p1, rate.l2p1], // 両方共p1の得点率になる
          },
          {
            label: this.gameInfo.player2Name,
            backgroundColor: '#83D7BD',
            data: [rate.l1p2, rate.l2p2],
          },
        ],
      };
    },
    optionData() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 1,
            },
          }],
          yAxes: [{
            stacked: true,
          }],
        },
      };
    },
    tableData(label) {
      const info = {
        p1: 0,
        p2: 0,
        s1: 0,
        s2: 0,
        sv: 0,
      };
      let table = [];
      let cnt = 0;
      const ret = [];
      for (let i = 0; i < this.points.length; i++) {
        // 得点推移
        if (this.points[i] === 1) {
          info.p1 += 1;
        } else {
          info.p2 += 1;
        }
        table.push(label.value[i]);
        ret[cnt] = table;
        // ゲーム終了判定
        if (info.p1 >= 11 || info.p2 >= 11) {
          if ((info.p1 - info.p2) ** 2 >= 4) {
            // 終了していた場合、初期化
            info.p1 = 0;
            info.p2 = 0;
            table = [];
            cnt += 1;
            if (info.s1 > info.s2) {
              info.s1 += 1;
            } else {
              info.s2 += 1;
            }
          }
        }
      }
      return ret;
    },
    getRate(points, manualLabel) {
      const info = { l1: [], l2: [] };
      const ret = { l1p1: 0, l2p1: 0, l1p2: 0, l2p2: 0 };
      for (let i = 0; i < points.length; i++) {
        if (manualLabel.value[i] === 1) {
          info.l1.push(points[i]);
        } else if (manualLabel.value[i] === 2) {
          info.l2.push(points[i]);
        }
      }
      if (info.l1.length > 0) {
        ret.l1p1 = func.round2(func.sumArr(info.l1) / info.l1.length);
        ret.l1p2 = func.round2(1 - ret.l1p1);
      }
      if (info.l2.length > 0) {
        ret.l2p1 = func.round2(func.sumArr(info.l2) / info.l2.length);
        ret.l2p2 = func.round2(1 - ret.l2p1);
      }
      return ret;
    },
  },
};
</script>
<style scoped>
.lblue{
    background-color: #82B8D7;
  }

.lgreen{
    background-color: #83D7BD;
}

.solid {
    border:solid 1px;
}
.no-border{
  border-top:0px;
}

</style>



// WEBPACK FOOTER //
// src/components/molecules/ManualLabelsChartWrap.vue